// import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom/client';
// import './App.css';
// import './header.css';
// import './footer.css';
// import Home from './component/home';
// import Login from './component/login';
// import useToken from './component/useToken';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
//
//
// function setToken(userToken) {
//     sessionStorage.setItem('token', JSON.stringify(userToken));
// }
//
// function getToken() {
//     const tokenString = sessionStorage.getItem('token');
//     const userToken = JSON.parse(tokenString);
//     return userToken?.token
// }
//
// function App() {
//     const [isAuthenticated, setIsAuthenticated] = useState(false);
//
//     const token = getToken();
//
//     console.log('============token==============',token);
//
//     if(!token) {
//         return <Login setToken={setToken} />
//     }
//
//     // // Check authentication status when the component mounts
//     // useEffect(() => {
//     //     const token = localStorage.getItem('token');
//     //     if (token) {
//     //         setIsAuthenticated(true); // If token exists, user is authenticated
//     //     }
//     // }, []); // Empty dependency array ensures this runs only once on mount
//
//     return (
//         <Router>
//             <Routes>
//                 <Route path="/login" element={<Login />} />
//                 <Route
//                     path="/home"
//                     element={isAuthenticated ? <Home /> : <Navigate to="/login" />}
//                 />
//                 <Route path="*" element={<Navigate to="/login" />} />
//             </Routes>
//         </Router>
//     );
// }
//
// export default App;
//
// // Render the app
// // const root = ReactDOM.createRoot(document.getElementById('root'));
// // root.render(<App />);

import React from 'react';
import  {  useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

import './App.css';
import './header.css';
import './footer.css';

import useToken from './component/useToken';
import Login from './component/login';
import Impersonate_Login from './component/impersonate_login';
import Dashboard from './component/dashboard';
import NoPage from './component/nopage';

function App() {
    const { token, setToken } = useToken();

    useEffect(() => {
         const link = document.querySelector("link[rel='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon';
        link.href = './favicon.ico';
        document.head.appendChild(link);
        document.title = 'Market Risk Desktop Dashboard';
        return () => {
            document.head.removeChild(link);
        };
    }, []);


    if (!token) {
        // console.log('=============set token ==============');
        // console.log(setToken);
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login setToken={setToken} />} />
                    <Route path="/impersonate_login" element={<Impersonate_Login setToken={setToken} />} />
                    <Route path="*" element={<Navigate to="/login" />}

                    />
                </Routes>
            </BrowserRouter>
        );
    }

    // console.log('=============token ==============');
    // console.log(token);

    return (
        <div className="wrapper">
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={token ? <Navigate to="/dashboard" /> : <Login setToken={setToken} />} />
                    <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />} />
                    <Route path="*" element={<Navigate to={token ? "/dashboard" : "/login"} />} />
                </Routes>
            </BrowserRouter>

        </div>
    );
}

export default App;


